'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = inject;

var _validators = require('../../utils/validators');

function inject(value) {
  return function (target, key, descriptor) {
    var userFunc = descriptor.value;

    (0, _validators.validateFunction)(userFunc, 'inject' + value.charAt(0).toUpperCase() + value.slice(1));

    return _extends({}, descriptor, {
      value: function Injector() {
        for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
          params[_key] = arguments[_key];
        }

        return userFunc.apply(this, [this[value]].concat(params));
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/functions/inject.js
// module id = 131
// module chunks = 1